"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareStrings = void 0;
function compareStrings(a, b) {
    return typeof a === 'string' && typeof b === 'string' ?
        a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0 :
        a === b;
}
exports.compareStrings = compareStrings;
